// ── postWatchAsk ─────────────────────────────────────────────────────────────
// Two leaks found in the 2026-10-31 audit of "the rating prompt doesn't always fire":
//  1. EpisodePulseHost is lazy-loaded. A mark that lands before its chunk is up (the
//     walkthrough's first show, a fast return visit) dispatched nextep:episode-watched
//     to nobody. useWatchlist now parks the last detail here; the host replays it on
//     mount if it is still fresh.
//  2. The host checked window.__nextepModalHold once, 900ms after the mark, and DROPPED
//     the ask if anything (What's New, an install/save sheet, a batch receipt) held
//     the screen at that instant. It now waits for the screen to clear, bounded.
// Pure, timer-injected, node-tested.
export const PENDING_MAX_AGE_MS = 8000
let pending = null
export function rememberWatched(detail, now = Date.now()) { pending = detail ? { detail, at: now } : null }
export function takePendingWatched(now = Date.now(), maxAge = PENDING_MAX_AGE_MS) {
  const p = pending; pending = null
  if (!p || now - p.at > maxAge) return null
  return p.detail
}

// Calls fn once the screen is clear; gives up after maxWaitMs. Returns cancel().
export function whenClear(fn, { isBusy, delayMs = 900, stepMs = 250, maxWaitMs = 20000, setT = setTimeout, clearT = clearTimeout, now = Date.now } = {}) {
  const started = now()
  let t = null, done = false
  const tick = () => {
    if (done) return
    if (!isBusy()) { done = true; fn(); return }
    if (now() - started >= maxWaitMs) { done = true; return }
    t = setT(tick, stepMs)
  }
  t = setT(tick, delayMs)
  return () => { done = true; clearT(t) }
}
export function _resetForTests() { pending = null }
